import { CardBase } from 'structure/home/components/CardBase';
import { twMerge } from 'tailwind-merge';
import Image from 'next/image';
import { Body2, Header2, Header5 } from 'structure/home/components/Typography';
import { getStaticAssetUrl } from 'utils/url';

interface Props {
  anchorId: string;
}

export const GridCards = ({ anchorId }: Props) => {
  return (
    <div id={anchorId} className='flex flex-col gap-12'>
      <Header2 className='text-center'>Discover Singularity Finance</Header2>
      <div className='grid grid-cols-1 gap-3 lg:grid-cols-7'>
        <Card
          className={'border border-positive-900 bg-black lg:col-span-4'}
          descriptionClassName='text-white'
          headingClassName='text-softYellow'
          icon={
            <Image
              alt='Finance_Platform'
              src={getStaticAssetUrl(
                '/sfi/static/homepage/finance_platform_yellow.png'
              )}
              width='40'
              height='40'
            />
          }
          title='AI Portfolio Management'
          description='Gain AI-driven insights to optimize holdings and make informed DeFi decisions effortlessly.'
        />
        <Card
          className={`border border-softYellow bg-positive-900 lg:col-span-3`}
          descriptionClassName='text-white'
          headingClassName='text-softYellow'
          icon={
            <Image
              alt='Tokenization'
              src={getStaticAssetUrl(
                '/sfi/static/homepage/tokenisation_yellow.png'
              )}
              width='40'
              height='40'
            />
          }
          title='AI Trading & Vaults'
          description='Boost profits with AI-powered trading and vaults, designed for simplicity and high returns.'
        />
        <Card
          className={`border border-black bg-softYellow text-black lg:col-span-3`}
          descriptionClassName='text-black'
          headingClassName='text-black'
          icon={
            <Image
              alt='Identity'
              src={getStaticAssetUrl('/sfi/static/homepage/Identity_black.png')}
              width='40'
              height='40'
            />
          }
          title='Trading Agents'
          description='Let AI execute smart trades with non-custodial agents launching in 2025 for efficiency.'
        />
        <Card
          className={`border border-positive-900 bg-[#ffffff] lg:col-span-4`}
          descriptionClassName='text-black'
          headingClassName='text-positive-900'
          icon={
            <Image
              alt='Vaults'
              src={getStaticAssetUrl('/sfi/static/homepage/vaults_green.png')}
              width='40'
              height='40'
            />
          }
          title='RWA Pod for ASI Chain'
          description='Singularity Finance’s RWA framework to propel the project forward'
        />
      </div>
    </div>
  );
};

interface CardProps {
  icon: React.ReactNode;
  title: string;
  className?: string;
  description: string;
  descriptionClassName?: string;
  headingClassName?: string;
}

const Card = (props: CardProps) => {
  const {
    title,
    className,
    icon,
    description,
    descriptionClassName,
    headingClassName,
  } = props;

  return (
    <CardBase className={twMerge('bg-[#D2E8C8] lg:col-span-4', className)}>
      <div className='ml-auto pb-10'>{icon}</div>
      <div className='flex flex-col gap-4'>
        <Header5 className={twMerge('text-xl normal-case', headingClassName)}>
          {title}
        </Header5>
        <Body2 className={twMerge('text-inherit', descriptionClassName)}>
          {description}
        </Body2>
      </div>
    </CardBase>
  );
};
